"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timing = exports.SelectionStatus = exports.SelectionKeySkillsLevel = exports.SelectionFreelanceAnswerEnum = exports.SelectionClientAnswerEnum = exports.Role = exports.RecommendationQuestionKeyEnum = exports.ProposalStatus = exports.ProjectedDurationUnitEnum = exports.PeriodEnum = exports.PaymentPeriodEnum = exports.OpportunityType = exports.NotificationStatusEnum = exports.MissionStatusEnum = exports.MissionPriorityEnum = exports.MissionMatchingFilterPriceEnum = exports.MissionMatchingFilterMarketSituationEnum = exports.MissionMatchingFilterGeographicAvailabilityEnum = exports.MissionMatchingFilterExpectedContractEnum = exports.MissionDuration = exports.Location = exports.JobState = exports.InsiderRoleEnum = exports.Gender = exports.FreelanceStatus = exports.FreelanceMissionProposalAnswerEnum = exports.FreelanceMiseAJourDisponibiliteStatusEnum = exports.FreelanceImportSourceEnum = exports.ExpectedContract = exports.CustomerIoCampaign = exports.ContractSortableFieldEnum = exports.CompanyForm = exports.ClientStatus = exports.ClientNoticePeriodUnitEnum = exports.ClientInitialPeriodUnitEnum = exports.ClientInitialPeriodStakeholdersEnum = exports.BusinessVariant = exports.Activity = void 0;
var Activity;
(function (Activity) {
    Activity["Freelance"] = "freelance";
    Activity["Salary"] = "salary";
    Activity["Student"] = "student";
})(Activity || (exports.Activity = Activity = {}));
var BusinessVariant;
(function (BusinessVariant) {
    BusinessVariant["Client"] = "client";
    BusinessVariant["Freelance"] = "freelance";
})(BusinessVariant || (exports.BusinessVariant = BusinessVariant = {}));
var ClientInitialPeriodStakeholdersEnum;
(function (ClientInitialPeriodStakeholdersEnum) {
    ClientInitialPeriodStakeholdersEnum["Frk"] = "FRK";
    ClientInitialPeriodStakeholdersEnum["FrkFreelance"] = "FRK_FREELANCE";
    ClientInitialPeriodStakeholdersEnum["None"] = "NONE";
})(ClientInitialPeriodStakeholdersEnum || (exports.ClientInitialPeriodStakeholdersEnum = ClientInitialPeriodStakeholdersEnum = {}));
var ClientInitialPeriodUnitEnum;
(function (ClientInitialPeriodUnitEnum) {
    ClientInitialPeriodUnitEnum["BusinessDays"] = "BUSINESS_DAYS";
    ClientInitialPeriodUnitEnum["Days"] = "DAYS";
})(ClientInitialPeriodUnitEnum || (exports.ClientInitialPeriodUnitEnum = ClientInitialPeriodUnitEnum = {}));
var ClientNoticePeriodUnitEnum;
(function (ClientNoticePeriodUnitEnum) {
    ClientNoticePeriodUnitEnum["BusinessDays"] = "BUSINESS_DAYS";
    ClientNoticePeriodUnitEnum["Days"] = "DAYS";
    ClientNoticePeriodUnitEnum["Month"] = "MONTH";
    ClientNoticePeriodUnitEnum["MonthEom"] = "MONTH_EOM";
})(ClientNoticePeriodUnitEnum || (exports.ClientNoticePeriodUnitEnum = ClientNoticePeriodUnitEnum = {}));
var ClientStatus;
(function (ClientStatus) {
    ClientStatus["Ko"] = "ko";
    ClientStatus["Ok"] = "ok";
    ClientStatus["Prospect"] = "prospect";
})(ClientStatus || (exports.ClientStatus = ClientStatus = {}));
var CompanyForm;
(function (CompanyForm) {
    CompanyForm["Ei"] = "EI";
    CompanyForm["Eirl"] = "EIRL";
    CompanyForm["EiAeMe"] = "EI_AE_ME";
    CompanyForm["Eurl"] = "EURL";
    CompanyForm["Sa"] = "SA";
    CompanyForm["Sarl"] = "SARL";
    CompanyForm["SarlEurl"] = "SARL_EURL";
    CompanyForm["Sas"] = "SAS";
    CompanyForm["Sasu"] = "SASU";
    CompanyForm["SasSasu"] = "SAS_SASU";
})(CompanyForm || (exports.CompanyForm = CompanyForm = {}));
var ContractSortableFieldEnum;
(function (ContractSortableFieldEnum) {
    ContractSortableFieldEnum["CreatedAt"] = "createdAt";
    ContractSortableFieldEnum["Number"] = "number";
    ContractSortableFieldEnum["Version"] = "version";
})(ContractSortableFieldEnum || (exports.ContractSortableFieldEnum = ContractSortableFieldEnum = {}));
var CustomerIoCampaign;
(function (CustomerIoCampaign) {
    CustomerIoCampaign["FreelanceMiseAJourDisponibilite"] = "freelanceMiseAJourDisponibilite";
    CustomerIoCampaign["FreelanceMissionProposal"] = "freelanceMissionProposal";
})(CustomerIoCampaign || (exports.CustomerIoCampaign = CustomerIoCampaign = {}));
var ExpectedContract;
(function (ExpectedContract) {
    ExpectedContract["Cdi"] = "CDI";
    ExpectedContract["Freelance"] = "FREELANCE";
    ExpectedContract["FreelanceOrCdi"] = "FREELANCE_OR_CDI";
    ExpectedContract["Nc"] = "NC";
})(ExpectedContract || (exports.ExpectedContract = ExpectedContract = {}));
var FreelanceImportSourceEnum;
(function (FreelanceImportSourceEnum) {
    FreelanceImportSourceEnum["Apec"] = "APEC";
    FreelanceImportSourceEnum["ClientReferral"] = "CLIENT_REFERRAL";
    FreelanceImportSourceEnum["FreelanceReferral"] = "FREELANCE_REFERRAL";
    FreelanceImportSourceEnum["Freework"] = "FREEWORK";
    FreelanceImportSourceEnum["Ib"] = "IB";
    FreelanceImportSourceEnum["JeanMichel"] = "JEAN_MICHEL";
    FreelanceImportSourceEnum["Linkedin"] = "LINKEDIN";
    FreelanceImportSourceEnum["Malt"] = "MALT";
    FreelanceImportSourceEnum["Organic"] = "ORGANIC";
    FreelanceImportSourceEnum["Other"] = "OTHER";
    FreelanceImportSourceEnum["PeopleDataLabs"] = "PEOPLE_DATA_LABS";
    FreelanceImportSourceEnum["PoleEmploi"] = "POLE_EMPLOI";
})(FreelanceImportSourceEnum || (exports.FreelanceImportSourceEnum = FreelanceImportSourceEnum = {}));
var FreelanceMiseAJourDisponibiliteStatusEnum;
(function (FreelanceMiseAJourDisponibiliteStatusEnum) {
    FreelanceMiseAJourDisponibiliteStatusEnum["Available"] = "available";
    FreelanceMiseAJourDisponibiliteStatusEnum["NotAvailableButListening"] = "notAvailableButListening";
    FreelanceMiseAJourDisponibiliteStatusEnum["NotListening"] = "notListening";
})(FreelanceMiseAJourDisponibiliteStatusEnum || (exports.FreelanceMiseAJourDisponibiliteStatusEnum = FreelanceMiseAJourDisponibiliteStatusEnum = {}));
var FreelanceMissionProposalAnswerEnum;
(function (FreelanceMissionProposalAnswerEnum) {
    FreelanceMissionProposalAnswerEnum["Ko"] = "ko";
    FreelanceMissionProposalAnswerEnum["Ok"] = "ok";
    FreelanceMissionProposalAnswerEnum["Unavailable"] = "unavailable";
})(FreelanceMissionProposalAnswerEnum || (exports.FreelanceMissionProposalAnswerEnum = FreelanceMissionProposalAnswerEnum = {}));
var FreelanceStatus;
(function (FreelanceStatus) {
    FreelanceStatus["Candidate"] = "candidate";
    FreelanceStatus["Former"] = "former";
    FreelanceStatus["Intest"] = "intest";
    FreelanceStatus["Ko"] = "ko";
    FreelanceStatus["Ok"] = "ok";
    FreelanceStatus["Pending"] = "pending";
    FreelanceStatus["Prospect"] = "prospect";
    FreelanceStatus["Runner"] = "runner";
    FreelanceStatus["Stashed"] = "stashed";
})(FreelanceStatus || (exports.FreelanceStatus = FreelanceStatus = {}));
var Gender;
(function (Gender) {
    Gender["F"] = "F";
    Gender["M"] = "M";
})(Gender || (exports.Gender = Gender = {}));
var InsiderRoleEnum;
(function (InsiderRoleEnum) {
    InsiderRoleEnum["Commercial"] = "COMMERCIAL";
    InsiderRoleEnum["TalentAdvocate"] = "TALENT_ADVOCATE";
})(InsiderRoleEnum || (exports.InsiderRoleEnum = InsiderRoleEnum = {}));
var JobState;
(function (JobState) {
    JobState["Completed"] = "completed";
    JobState["Failed"] = "failed";
    JobState["Pending"] = "pending";
})(JobState || (exports.JobState = JobState = {}));
var Location;
(function (Location) {
    Location["Both"] = "both";
    Location["Onsite"] = "onsite";
    Location["Remote"] = "remote";
})(Location || (exports.Location = Location = {}));
var MissionDuration;
(function (MissionDuration) {
    MissionDuration["BetweenSixAndTwelveMonths"] = "betweenSixAndTwelveMonths";
    MissionDuration["BetweenThreeAndSixMonths"] = "betweenThreeAndSixMonths";
    MissionDuration["LessThanThreeMonths"] = "lessThanThreeMonths";
    MissionDuration["MoreThanTwelveMonths"] = "moreThanTwelveMonths";
    MissionDuration["None"] = "none";
})(MissionDuration || (exports.MissionDuration = MissionDuration = {}));
var MissionMatchingFilterExpectedContractEnum;
(function (MissionMatchingFilterExpectedContractEnum) {
    MissionMatchingFilterExpectedContractEnum["IncludeUnknown"] = "INCLUDE_UNKNOWN";
    MissionMatchingFilterExpectedContractEnum["OnlyKnown"] = "ONLY_KNOWN";
})(MissionMatchingFilterExpectedContractEnum || (exports.MissionMatchingFilterExpectedContractEnum = MissionMatchingFilterExpectedContractEnum = {}));
var MissionMatchingFilterGeographicAvailabilityEnum;
(function (MissionMatchingFilterGeographicAvailabilityEnum) {
    MissionMatchingFilterGeographicAvailabilityEnum["MatchAddressOnly"] = "MATCH_ADDRESS_ONLY";
    MissionMatchingFilterGeographicAvailabilityEnum["MatchOneOfAvailability"] = "MATCH_ONE_OF_AVAILABILITY";
})(MissionMatchingFilterGeographicAvailabilityEnum || (exports.MissionMatchingFilterGeographicAvailabilityEnum = MissionMatchingFilterGeographicAvailabilityEnum = {}));
var MissionMatchingFilterMarketSituationEnum;
(function (MissionMatchingFilterMarketSituationEnum) {
    MissionMatchingFilterMarketSituationEnum["IsListening"] = "IS_LISTENING";
    MissionMatchingFilterMarketSituationEnum["IsListeningFresh"] = "IS_LISTENING_FRESH";
})(MissionMatchingFilterMarketSituationEnum || (exports.MissionMatchingFilterMarketSituationEnum = MissionMatchingFilterMarketSituationEnum = {}));
var MissionMatchingFilterPriceEnum;
(function (MissionMatchingFilterPriceEnum) {
    MissionMatchingFilterPriceEnum["Plus_100"] = "PLUS_100";
    MissionMatchingFilterPriceEnum["Plus_200"] = "PLUS_200";
})(MissionMatchingFilterPriceEnum || (exports.MissionMatchingFilterPriceEnum = MissionMatchingFilterPriceEnum = {}));
var MissionPriorityEnum;
(function (MissionPriorityEnum) {
    MissionPriorityEnum["Priority_0"] = "PRIORITY_0";
    MissionPriorityEnum["Priority_1"] = "PRIORITY_1";
    MissionPriorityEnum["Priority_2"] = "PRIORITY_2";
    MissionPriorityEnum["Priority_3"] = "PRIORITY_3";
})(MissionPriorityEnum || (exports.MissionPriorityEnum = MissionPriorityEnum = {}));
var MissionStatusEnum;
(function (MissionStatusEnum) {
    MissionStatusEnum["Archive"] = "ARCHIVE";
    MissionStatusEnum["DealAfter"] = "DEAL__AFTER";
    MissionStatusEnum["DealBefore"] = "DEAL__BEFORE";
    MissionStatusEnum["DealOngoing"] = "DEAL__ONGOING";
    MissionStatusEnum["InterviewActive"] = "INTERVIEW__ACTIVE";
    MissionStatusEnum["InterviewStop"] = "INTERVIEW__STOP";
    MissionStatusEnum["PropositionActive"] = "PROPOSITION__ACTIVE";
    MissionStatusEnum["PropositionStop"] = "PROPOSITION__STOP";
    MissionStatusEnum["QualificationActive"] = "QUALIFICATION__ACTIVE";
    MissionStatusEnum["QualificationStop"] = "QUALIFICATION__STOP";
    MissionStatusEnum["SearchActive"] = "SEARCH__ACTIVE";
    MissionStatusEnum["SearchStop"] = "SEARCH__STOP";
})(MissionStatusEnum || (exports.MissionStatusEnum = MissionStatusEnum = {}));
var NotificationStatusEnum;
(function (NotificationStatusEnum) {
    NotificationStatusEnum["Failure"] = "FAILURE";
    NotificationStatusEnum["Info"] = "INFO";
    NotificationStatusEnum["Success"] = "SUCCESS";
    NotificationStatusEnum["Warning"] = "WARNING";
})(NotificationStatusEnum || (exports.NotificationStatusEnum = NotificationStatusEnum = {}));
var OpportunityType;
(function (OpportunityType) {
    OpportunityType["Cdi"] = "CDI";
    OpportunityType["Freelancing"] = "FREELANCING";
})(OpportunityType || (exports.OpportunityType = OpportunityType = {}));
var PaymentPeriodEnum;
(function (PaymentPeriodEnum) {
    PaymentPeriodEnum["EndOfMonth"] = "END_OF_MONTH";
    PaymentPeriodEnum["FifteenDays"] = "FIFTEEN_DAYS";
    PaymentPeriodEnum["FortyfiveDays"] = "FORTYFIVE_DAYS";
    PaymentPeriodEnum["FortyfiveDaysEom"] = "FORTYFIVE_DAYS_EOM";
    PaymentPeriodEnum["FortyfiveDaysEomTenth"] = "FORTYFIVE_DAYS_EOM_TENTH";
    PaymentPeriodEnum["SixtyDays"] = "SIXTY_DAYS";
    PaymentPeriodEnum["SixtyDaysEom"] = "SIXTY_DAYS_EOM";
    PaymentPeriodEnum["SixtyDaysEomTenth"] = "SIXTY_DAYS_EOM_TENTH";
    PaymentPeriodEnum["ThirtyDays"] = "THIRTY_DAYS";
    PaymentPeriodEnum["ThirtyDaysEom"] = "THIRTY_DAYS_EOM";
    PaymentPeriodEnum["ThirtyDaysEomTenth"] = "THIRTY_DAYS_EOM_TENTH";
    PaymentPeriodEnum["TwentyDays"] = "TWENTY_DAYS";
    PaymentPeriodEnum["UponReceipt"] = "UPON_RECEIPT";
})(PaymentPeriodEnum || (exports.PaymentPeriodEnum = PaymentPeriodEnum = {}));
var PeriodEnum;
(function (PeriodEnum) {
    PeriodEnum["P0W"] = "P0W";
    PeriodEnum["P1M"] = "P1M";
    PeriodEnum["P1W"] = "P1W";
    PeriodEnum["P2M"] = "P2M";
    PeriodEnum["P2W"] = "P2W";
    PeriodEnum["P3M"] = "P3M";
    PeriodEnum["P3W"] = "P3W";
})(PeriodEnum || (exports.PeriodEnum = PeriodEnum = {}));
var ProjectedDurationUnitEnum;
(function (ProjectedDurationUnitEnum) {
    ProjectedDurationUnitEnum["BusinessDays"] = "BUSINESS_DAYS";
    ProjectedDurationUnitEnum["Days"] = "DAYS";
    ProjectedDurationUnitEnum["Month"] = "MONTH";
})(ProjectedDurationUnitEnum || (exports.ProjectedDurationUnitEnum = ProjectedDurationUnitEnum = {}));
var ProposalStatus;
(function (ProposalStatus) {
    ProposalStatus["InInterview"] = "IN_INTERVIEW";
    ProposalStatus["IsApplying"] = "IS_APPLYING";
    ProposalStatus["IsArchived"] = "IS_ARCHIVED";
    ProposalStatus["IsInterested"] = "IS_INTERESTED";
    ProposalStatus["IsRunner"] = "IS_RUNNER";
    ProposalStatus["WaitForClientAnswer"] = "WAIT_FOR_CLIENT_ANSWER";
})(ProposalStatus || (exports.ProposalStatus = ProposalStatus = {}));
var RecommendationQuestionKeyEnum;
(function (RecommendationQuestionKeyEnum) {
    RecommendationQuestionKeyEnum["Custom"] = "custom";
    RecommendationQuestionKeyEnum["Desc"] = "desc";
    RecommendationQuestionKeyEnum["Hiring"] = "hiring";
    RecommendationQuestionKeyEnum["Human"] = "human";
    RecommendationQuestionKeyEnum["Involvement"] = "involvement";
    RecommendationQuestionKeyEnum["Summary"] = "summary";
    RecommendationQuestionKeyEnum["Task"] = "task";
    RecommendationQuestionKeyEnum["Team"] = "team";
    RecommendationQuestionKeyEnum["Tech"] = "tech";
})(RecommendationQuestionKeyEnum || (exports.RecommendationQuestionKeyEnum = RecommendationQuestionKeyEnum = {}));
var Role;
(function (Role) {
    Role["Admin"] = "ADMIN";
    Role["All"] = "ALL";
    Role["Client"] = "CLIENT";
    Role["Commercial"] = "COMMERCIAL";
    Role["Freelance"] = "FREELANCE";
    Role["FrkSignatory"] = "FRK_SIGNATORY";
    Role["Logged"] = "LOGGED";
    Role["TalentAdvocate"] = "TALENT_ADVOCATE";
    Role["Tech"] = "TECH";
    Role["Und"] = "UND";
    Role["Unlogged"] = "UNLOGGED";
})(Role || (exports.Role = Role = {}));
var SelectionClientAnswerEnum;
(function (SelectionClientAnswerEnum) {
    SelectionClientAnswerEnum["AgreementNo"] = "AGREEMENT_NO";
    SelectionClientAnswerEnum["AgreementWaiting"] = "AGREEMENT_WAITING";
    SelectionClientAnswerEnum["AgreementYes"] = "AGREEMENT_YES";
    SelectionClientAnswerEnum["Ko"] = "ko";
    SelectionClientAnswerEnum["None"] = "none";
    SelectionClientAnswerEnum["Ok"] = "ok";
    SelectionClientAnswerEnum["Pending"] = "pending";
})(SelectionClientAnswerEnum || (exports.SelectionClientAnswerEnum = SelectionClientAnswerEnum = {}));
var SelectionFreelanceAnswerEnum;
(function (SelectionFreelanceAnswerEnum) {
    SelectionFreelanceAnswerEnum["AgreementNo"] = "AGREEMENT_NO";
    SelectionFreelanceAnswerEnum["AgreementWaiting"] = "AGREEMENT_WAITING";
    SelectionFreelanceAnswerEnum["AgreementYes"] = "AGREEMENT_YES";
    SelectionFreelanceAnswerEnum["Ko"] = "ko";
    SelectionFreelanceAnswerEnum["None"] = "none";
    SelectionFreelanceAnswerEnum["Ok"] = "ok";
    SelectionFreelanceAnswerEnum["Pending"] = "pending";
    SelectionFreelanceAnswerEnum["Unavailable"] = "unavailable";
})(SelectionFreelanceAnswerEnum || (exports.SelectionFreelanceAnswerEnum = SelectionFreelanceAnswerEnum = {}));
var SelectionKeySkillsLevel;
(function (SelectionKeySkillsLevel) {
    SelectionKeySkillsLevel["Level_0"] = "LEVEL_0";
    SelectionKeySkillsLevel["Level_1"] = "LEVEL_1";
    SelectionKeySkillsLevel["Level_2"] = "LEVEL_2";
    SelectionKeySkillsLevel["Level_3"] = "LEVEL_3";
})(SelectionKeySkillsLevel || (exports.SelectionKeySkillsLevel = SelectionKeySkillsLevel = {}));
var SelectionStatus;
(function (SelectionStatus) {
    SelectionStatus["Interview"] = "interview";
    SelectionStatus["Ko"] = "ko";
    SelectionStatus["Ok"] = "ok";
    SelectionStatus["PendingClient"] = "pendingClient";
    SelectionStatus["PendingFreelance"] = "pendingFreelance";
    SelectionStatus["Selected"] = "selected";
})(SelectionStatus || (exports.SelectionStatus = SelectionStatus = {}));
var Timing;
(function (Timing) {
    Timing["Both"] = "both";
    Timing["Full"] = "full";
    Timing["Partial"] = "partial";
    Timing["Partial_3"] = "partial_3";
    Timing["Partial_4"] = "partial_4";
})(Timing || (exports.Timing = Timing = {}));
//# sourceMappingURL=types.generated.js.map